import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "../style/InterviewsCarousel.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import drmaan from "../images/maan-abadi.jpg";
import drmohamed from "../images/mo-yaseen.jpg";

const InterviewCarousel = () => {
  const sliderRef = useRef(null);

  const slides = [
    {
      title: "MEET THE EXPERTS BEHIND YOUR SMILE",
      subtitle: "Chief Orthodontist – Dr. Maan Abadi",
      src: drmaan,
      description:
        "Dr. Maan Abadi leads Lamaan’s team of dentists and orthodontists. With over 30 years of experience in dentistry, he is a well‑respected and trusted practitioner in Lebanon. Before founding Lamaan, he dedicated his career to providing top‑quality dental care.",
    },
    {
      title: "MEET THE EXPERTS BEHIND YOUR SMILE",
      subtitle: "Dentist – Dr. Mohamed Yaseen",
      src: drmohamed,
      description:
        "Dr. Mohamed Yaseen is a valued member of Lamaan’s expert dental team. Before joining Lamaan, he taught dental courses at the Lebanese University’s School of Dentistry, sharing his knowledge and expertise with future dental professionals.",
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className={styles.carouselContainer}>
      <Slider {...settings} ref={sliderRef}>
        {slides.map((item, index) => (
          <div key={index} className={styles.slide}>
            <div className={styles.imageContainer}>
              <img
                src={item.src}
                alt={item.subtitle}
                className={styles.sliderImage}
              />
            </div>
            <div className={styles.textContainer}>
              <h2 className={styles.videoTitle}>{item.title}</h2>
              <h3 className={styles.secondTitle}>{item.subtitle}</h3>
              <p className={styles.videoDescription}>{item.description}</p>
            </div>
          </div>
        ))}
      </Slider>

      {/* Navigation Buttons */}
      <div className={styles.buttonWrapper}>
        <button
          type="button"
          className={`${styles.customButton} ${styles.prevButton}`}
          onClick={() => sliderRef.current?.slickPrev()}
        >
          <FontAwesomeIcon icon={faChevronLeft} size="2x" />
        </button>
        <button
          type="button"
          className={`${styles.customButton} ${styles.nextButton}`}
          onClick={() => sliderRef.current?.slickNext()}
        >
          <FontAwesomeIcon icon={faChevronRight} size="2x" />
        </button>
      </div>
    </div>
  );
};

export default InterviewCarousel;
